import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { resolveSetPlatformAdmin } from '../server/resolvers/resolveSetPlatformAdmin.js';

/**
 * The only way `isPlatformAdmin` is ever written from outside the server.
 *
 * The field is declared with a resolver, so `toObject(true)` drops it and the
 * generic entity update physically cannot carry it — this mutation is not merely
 * the preferred path, it is the only one. See `SaraaUser.isPlatformAdmin`.
 */
const setPlatformAdmin = registerMutation({
  operationName: 'setPlatformAdmin',
  type: () => Boolean,
  params: [
    { name: 'userId', type: () => ID },
    { name: 'isPlatformAdmin', type: () => Boolean },
  ],
  resolve: resolveSetPlatformAdmin,
});

export const PlatformAdminAPI = { set: setPlatformAdmin };
